import Enums from "Enums";
import Rest from "Utils/Rest";

export default class ResourceUrlsService {
    getPatientImageUrl(documentId: string, fileExtension: string, generateWriteUrl) {
        return Rest.GET<string>("ResourceUrls/ResourceUrl/Images/Patients", { documentId, fileExtension, generateWriteUrl});
    }

    getResourceUrlRead(fileName: string, resourcePath: string, thumbnail: boolean, encrypted: boolean) {
        return Rest.GET<string>("ResourceUrls/GetResourceUrlRead?fileName=" + fileName + "&resourcePath=" + resourcePath +
            "&thumbnail=" + thumbnail + "&encrypted=" + encrypted, {});
    }

    getResourceUrlWrite(fileName: string, resourcePathKey: string) {
        return Rest.GET<string>("ResourceUrls/GetResourceUrlWrite?fileName=" + fileName + "&resourcePathKey=" + resourcePathKey, {});
    }

    getSharedResourceUrlRead(resourcePath: string, fileName: string) {
        return Rest.GET<string>("ResourceUrls/GetSharedResourceUrlRead?resourcePath=" + resourcePath + "&fileName=" + fileName, {});
    }

    getProfileImageUrlWrite(fileName: string) {
        return Rest.GET<NetHealth.EHR.Domain.Models.ImageUrlModel>("ResourceUrls/GetProfileImageUrlWrite?fileName=" + fileName, {});
    }

    getResourceUrlWriteByPath(fileName: string, resourcePath: string) {
        return Rest.GET<string>("ResourceUrls/getResourceUrlWriteByPath", { fileName, resourcePath });
    }

    deleteResource(imageName: string, resourcePath: string) {
        return Rest.DELETE<string>("ResourceUrls/DeleteResource?resourcePath=" + resourcePath + "&imageName=" + imageName, {});
    }

    getSasWritableUrl(folder: string = "", ext: string = "") {
        return Rest.GET<NetHealth.EHR.Domain.Models.ImageUrlModel>("ResourceUrls/GetSasWritableUrl?folder=" + folder + "&ext=" + ext, {});
    }

    getSasReadUrl(fileName: string, folderType: Enums.WoundExpertFileType, isThumbnail: boolean = false, encrypted: boolean = false ) {
        return Rest.GET<NetHealth.EHR.Domain.Models.ImageUrlModel>("ResourceUrls/GetSasReadUrl?fileName=" + fileName + "&folderType=" + folderType + "&isThumbnail=" + isThumbnail + "&encrypted="  + encrypted, {});
    }

    getSasFacilityUrl(fileType: string) {
        return Rest.GET<string>("ResourceUrls/GetSasFacilityUrl?fileType=" + fileType, {});
    }

    getCreateSasTempThumbnailUrl(fileName: string) {
        return Rest.GET<NetHealth.EHR.Domain.Models.ImageUrlModel>("ResourceUrls/GetCreateSasTempThumbnailUrl?fileName=" + fileName, {});
    }
}